import React, { useState } from 'react'

function PaymentOptions({ selectedOption, onSelect }) {
    const [option, setOption] = useState(selectedOption || 'Cash')

    const handleChange = (value) => {
        setOption(value)
        if (onSelect) {
            onSelect(value)
        }
    }

    return (
        <div className="mb-6">
            <h3 className="font-semibold text-lg mb-3">Payment Method</h3>
            <div className="space-y-3">
                <label className={`flex items-center p-3 border rounded-lg cursor-pointer transition ${option === 'Cash'
                        ? 'border-primary bg-primary/10'
                        : 'border-gray-200 hover:border-primary/50'
                    }`}>
                    <input
                        type="radio"
                        name="paymentMethod"
                        value="Cash"
                        checked={option === 'Cash'}
                        onChange={() => handleChange('Cash')}
                        className="sr-only"
                    />
                    <span className={`w-4 h-4 rounded-full mr-3 flex items-center justify-center ${option === 'Cash'
                            ? 'bg-primary border-2 border-white'
                            : 'border-2 border-gray-300'
                        }`}>
                        {option === 'Cash' && (
                            <span className="w-2 h-2 bg-white rounded-full"></span>
                        )}
                    </span>
                    <span className="text-sm font-medium">Cash on Delivery</span>
                </label>

                <label className={`flex items-center p-3 border rounded-lg cursor-pointer transition ${option === 'MPESA'
                        ? 'border-primary bg-primary/10'
                        : 'border-gray-200 hover:border-primary/50'
                    }`}>
                    <input
                        type="radio"
                        name="paymentMethod"
                        value="mpesa"
                        checked={option === 'MPESA'}
                        onChange={() => handleChange('MPESA')}
                        className="sr-only"
                    />
                    <span className={`w-4 h-4 rounded-full mr-3 flex items-center justify-center ${option === 'MPESA'
                            ? 'bg-primary border-2 border-white'
                            : 'border-2 border-gray-300'
                        }`}>
                        {option === 'MPESA' && (
                            <span className="w-2 h-2 bg-white rounded-full"></span>
                        )}
                    </span>
                    <span className="text-sm font-medium">MPESA</span>
                </label>

                <label className={`flex items-center p-3 border rounded-lg cursor-pointer transition ${option === 'other'
                        ? 'border-primary bg-primary/10'
                        : 'border-gray-200 hover:border-primary/50'
                    }`}>
                    <input
                        type="radio"
                        name="paymentMethod"
                        value="other"
                        checked={option === 'other'}
                        onChange={() => handleChange('other')}
                        className="sr-only"
                    />
                    <span className={`w-4 h-4 rounded-full mr-3 flex items-center justify-center ${option === 'other'
                            ? 'bg-primary border-2 border-white'
                            : 'border-2 border-gray-300'
                        }`}>
                        {option === 'other' && (
                            <span className="w-2 h-2 bg-white rounded-full"></span>
                        )}
                    </span>
                    <span className="text-sm font-medium">Other (e.g. Card)</span>
                </label>
            </div>
        </div>
    )
}

export default PaymentOptions